import styled from 'styled-components';
import { getSpacing, typography } from 'stylesheet';

export const ErrorApiResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
`;

export const ErrorApiResponseImage = styled.img`
  width: 163px;
  height: 123px;
`;

export const ErrorApiResponseTitle = styled.h3`
  margin-top: ${getSpacing(2)};
  ${typography.title_small};
  text-align: center;
`;

export const ErrorApiResponseDescription = styled.h3`
  margin-top: ${getSpacing(3)};
  text-align: center;
`;
